import { connect } from "react-redux";

import actions from "../../actions";
import ScheduleEditorBundleChiba from "../../components/list/ScheduleEditorBundleChiba";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateItemBundle: (data, handleSuccess, handleCancel) =>
      dispatch(actions.schedule_chiba.updateItemBundle(data, handleSuccess, handleCancel)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleEditorBundleChiba);
